import React, { useEffect } from "react";
import queryString from 'query-string';

// services
import { showMessage } from "services/message.js";
import { api_GET } from "services/api_service.js";

// Views
import AgendamentoVistoria from "views/Shared/Transportador/AgendamentoVistoria";

export default function AgendamentoVistoriaPortal({ history }) {

    const [showLoading, setshowLoading] = React.useState(false);

    const [rowEdit, set_rowEdit] = React.useState(null);
    const loadItem = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);
        if (params != null && params.protocolo != null && params.requerimento != null) {
            setshowLoading(true);
            api_GET(`AgendamentoVistoria/GetItemListByProtocoloAndRequerimento/${params.protocolo}/${params.requerimento}`).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    set_rowEdit(result.data);
                }
            });
        }
        else {
            showMessage("Aviso", "URL inválida!", 'error', null);
        }
    }

    useEffect(() => {
        loadItem();
    }, []);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <img src={require("assets/img/loading.gif")}></img>
                    </div>
                </div>
            }
            {rowEdit &&
                <AgendamentoVistoria requerimentoAgendamento={rowEdit}></AgendamentoVistoria>
            }
        </>
    );
}